export default function RenderMarkups(markupString) {
    return {__html: markupString};
}